export const WatchlistStatus = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  REVIEW: 'REVIEW',
  PASSED: 'PASSED',
  FAILED: 'FAILED',
};
